"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cgui_core_atoms_typography_1 = require("@campgladiator/cgui-core.atoms.typography");
const cgui_core_atoms_icon_1 = require("@campgladiator/cgui-core.atoms.icon");
const cgui_core_atoms_button_1 = require("@campgladiator/cgui-core.atoms.button");
const alert_module_scss_1 = __importDefault(require("./alert.module.scss"));
const Alert = (_a) => {
    var { className = "", size = "default", alertType = "info", theme = "dark", title = "", icon, dismissable = false, button = {
        onClick: () => { },
        icon,
        disabled: false,
        text: "",
    }, onDismiss = () => { }, children } = _a, props = __rest(_a, ["className", "size", "alertType", "theme", "title", "icon", "dismissable", "button", "onDismiss", "children"]);
    const [visible, setVisible] = (0, react_1.useState)(true);
    const buttonEmphasis = alertType === "info" ? "secondary" : "primary";
    const titleSize = size === "xsmall"
        ? "small"
        : size === "small"
            ? "default"
            : size === "default"
                ? "large"
                : size === "large"
                    ? "xlarge"
                    : "default";
    const handleOnDismiss = () => {
        setVisible(false);
        onDismiss();
    };
    return (visible && (react_1.default.createElement("section", Object.assign({ className: (0, classnames_1.default)(alert_module_scss_1.default.alert, className), "data-size": size, "data-type": alertType, "data-theme": theme }, props),
        (!!icon || !!title || dismissable) && (react_1.default.createElement("header", { className: alert_module_scss_1.default.header },
            (icon === null || icon === void 0 ? void 0 : icon.type) === "solid" && (react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Solid, { className: `${alert_module_scss_1.default.icon}`, name: icon.name, "data-size": size })),
            (icon === null || icon === void 0 ? void 0 : icon.type) === "line" && (react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Line, { className: `${alert_module_scss_1.default.icon}`, name: icon.name, "data-size": size })),
            title && (react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { weight: "bold", size: titleSize, className: alert_module_scss_1.default.title }, title)),
            dismissable && (react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Line, { className: alert_module_scss_1.default.close, name: "icon-times", onClick: handleOnDismiss })))),
        children && (react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: size, weight: "book", className: alert_module_scss_1.default.content }, children)),
        button.text && (react_1.default.createElement("footer", { className: alert_module_scss_1.default.footer },
            react_1.default.createElement(cgui_core_atoms_button_1.Button, { onClick: button.onClick, size: size, disabled: button.disabled, emphasis: buttonEmphasis, icon: button.icon }, button.text))))));
};
exports.default = (0, react_1.memo)(Alert);
//# sourceMappingURL=alert.js.map